
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IReporterItemData } from '@/types/reporter-types'

@Component({
    name: 'ReporterTable',
    components: {
    }
})
export default class extends Vue {
    @Prop({ required: true }) private reporters!: IReporterItemData[]

    private async onTapOriginNews(data: any) {
        window.open('/news/' + data.id)
    }

    private onGoNewsList(data: any) {
        window.open('/news/list?reporterId=' + data.id + '&name=' + data.name)
    }

    private onTapMedia(data: any) {
        window.open('/media/' + data.id + '/edit')
    }

    private TypeFormatter(row: any, column: any, cellValue: any) {
        const typeMap = {
            0: '记者',
            1: '特邀记者',
            2: '通讯员',
            3: '投稿作者',
            4: '实习生'
        }
        return Reflect.get(typeMap, cellValue)
    }
}
